/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';
import { SAVE_QUEUE_SETTINGS_SAGA } from '../features/queue-settings';

import { getCBXSocket } from '../web-socket/client';

// eslint-disable-next-line require-yield
function* saveQueueSettingsHandler(action: any) {
  const data = action.payload;
  const socketClient = getCBXSocket();
  if (socketClient) {
    socketClient.send({
      cmd: 'booth/save-queue-settings',
      ...data
    });
  }
}

export function* saveQueueSettingsSaga() {
  yield takeLatest(SAVE_QUEUE_SETTINGS_SAGA, saveQueueSettingsHandler);
}
